import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {reposListAppBuilder} from './config/app-builder'
import {repositoriesPageRoute} from './routes/repositories-page-route'
import {RepositoriesPageForDataRouter, RepositoriesPageForNavigator} from './routes/RepositoriesPage'

// We register the 'repos-list' app **twice**. Once as a DataRouter app and once as a Navigator app.
// A FF in the Rails controller determines which app is used at runtime.
// '/repos' route is ALWAYS a Navigator app for now, which is a temporary route until we build 'repos-finder' package.

registerNavigatorApp('repos-list', () => ({
  App,
  routes: [jsonRoute({path: '/orgs/:org/repositories', Component: RepositoriesPageForNavigator})],
}))

export const reposListApp = reposListAppBuilder.createDataRouterAppFromRoutes([
  repositoriesPageRoute.toRoute({Component: RepositoriesPageForDataRouter}),
])
registerDataRouterApp(reposListApp)
